import { render } from "./EmployeeLocationWidget.vue?vue&type=template&id=20086bd6&scoped=true"
import script from "./EmployeeLocationWidget.vue?vue&type=script&lang=js"
export * from "./EmployeeLocationWidget.vue?vue&type=script&lang=js"

import "./EmployeeLocationWidget.vue?vue&type=style&index=0&id=20086bd6&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20086bd6"]])

export default __exports__